import Close from '@mui/icons-material/Close'
import ContactMail from '@mui/icons-material/ContactMail'
import CircularProgress from '@mui/material/CircularProgress'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import TextField from '@mui/material/TextField'
import React, { useContext, useEffect, useState } from 'react'
import MyContext from '../../Context/AppContext';
import { showToast } from '../../utils/toastUtils';
import SupportMailSend from '../../Apis/SupportMailSend';

const UpgradeContactModal = () => {
    const { upgradeModalOpen, setUpgradeModalOpen, userDetails } = useContext(MyContext);
    const [message, setMessage] = useState('')
    const [email, setEmail] = useState('')
    const [loading, setLoading] = useState(false)
    const [emailDisabled, setEmailDisabled] = useState(false)
    const subject = 'Enabling additional Noah functionalities'

    const handleClose = () => {
        setUpgradeModalOpen(false)
        setMessage('')
        setEmail('')
        setEmailDisabled(false)
    }

    const handleSendMessage = async () => {
        try {
            if (message === '' || email === '') {
                showToast('Please fill all required fields', 'error')
                return
            }
            setLoading(true)
            let data = {
                recipientEmail: 'sales@nlbservices.com',
                message: message,
                userEmail: email,
                subject: subject
            }
            let response = await SupportMailSend(data)
            if (response.status === 200) {
                showToast('Message Sent Successfully', 'success')
                handleClose()
            }

        } catch (error) {
            showToast('Something went wrong', 'error')
            console.log(error)
        }
        finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        // Always handle userDetails changes, even if modal is not open
        if (userDetails) {
            setEmail(userDetails.email)
            setEmailDisabled(true)
        } else {
            // Force clear email on logout
            setEmail('')
            setEmailDisabled(false)
        }
    }, [userDetails])

    return (
        <Dialog
            onClose={() => handleClose()}
            open={upgradeModalOpen}
            maxWidth='md'
            fullWidth
        >
            <DialogTitle className='dialogTitle_usageDialog'>
                <div className='headerSection_usageDialog'>
                    <div className='dialogTitle'>
                        <ContactMail />
                        <span>Upgrade Features</span>
                    </div>
                    <IconButton
                        onClick={() => handleClose()}
                    >
                        <Close className='closeButton_usageModal' />
                    </IconButton>
                </div>
            </DialogTitle>
            <DialogContent className='dialogContainer_contacUs'>
                <span>Subject</span>
                <TextField
                    className='textField_contactUs'
                    variant="outlined"
                    value={subject}
                    disabled={true}
                />
                <span>Email Address</span>
                <TextField
                    className='textField_contactUs'
                    id="outlined-basic"
                    variant="outlined"
                    placeholder='Enter your email address...'
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    disabled={emailDisabled}
                />
                <span>Your Message</span>
                <TextField
                    className='textField_contactUs'
                    id="outlined-multiline-flexible"
                    multiline
                    rows={6}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder='Enter your message...'
                />
                <div className='buttonContainer'>
                    <button className={!loading ? 'sendButton' : 'sendButton sendDisabled'} onClick={() => handleSendMessage()} disabled={loading}>
                        <span>{loading ? "Please wait..." : "Send Message"}</span>
                        {loading && <CircularProgress className='cp_loginButton' />}
                    </button>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default UpgradeContactModal
